import Head from "next/head"
import { useSession } from "next-auth/client"
import { resetProgress } from "../modules/courses/services/progress"

export default function Account() {
  const [session, sessionLoading] = useSession()

  const handleBillingPortal = async () => {
    try {
      const res = await fetch("/api/billing/billing_portal", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: session?.user?.email }),
      })
      const data = await res.json()

      if (data.error) {
        console.error("Unable to get billing portal link")
        return
      }
      if (typeof window !== "undefined") {
        window.location = data.url
      }
    } catch (error) {}
  }

  const handleReset = () => {
    const shouldReset = confirm("Are you sure you want to reset all of your progress?")
    if (shouldReset) {
      resetProgress()
    }
  }

  return (
    <div className="app-wrapper">
      <Head>
        <title>Account | Skillfyre</title>
      </Head>
      <h1 className="text-2xl font-semibold">Account</h1>

      <section className="mt-4">
        <h2 className="text-lg font-semibold">Manage Plan</h2>
        <p className="text-gray-600 max-w-prose">
          View or update your plan settings via Stripe including payment and contact info. To cancel
          your subscription, please contact us{" "}
          <a
            className="text-primary-600 font-semibold hover:text-primary-700"
            target="_blank"
            rel="noreferrer noopener"
            href="mailto:hello@skillfyre.com?subject=Cancel%20subscription">
            hello@skillfyre.com
          </a>
        </p>
        <button
          disabled={sessionLoading}
          className="btn-secondary mt-2"
          onClick={handleBillingPortal}>
          Manage plan
        </button>
      </section>

      <section className="mt-8">
        <h2 className="text-lg font-semibold">Progress</h2>
        <p className="text-gray-600 max-w-prose">Reset all course progress.</p>
        <button className="btn-secondary mt-3 hover:text-red-500" onClick={handleReset}>
          Reset Progress
        </button>
      </section>

      <section className="mt-8">
        <h2 className="text-lg font-semibold">Support</h2>
        <p className="text-gray-600 max-w-prose">
          Please contact us with any questions or concerns you may have at{" "}
          <a
            className="text-primary-600 font-semibold hover:text-primary-700"
            target="_blank"
            rel="noreferrer noopener"
            href="mailto:hello@skillfyre.com?subject=Support">
            hello@skillfyre.com
          </a>
          .
        </p>
      </section>
    </div>
  )
}

Account.authRequired = true
